import { useState } from "react";
import { withRouter } from "react-router";
import { MainList } from "components";

import ModalEditWarehouse from "./components/ModalEditWarehouse";
import ModalDeleteWarehouse from "./components/ModalDeleteWarehouse";

import { sort, filters } from "./const/data";
import ModalCreateWarehouse from "./components/ModalCreateWarehouse";

const default_state = { type: null, data: null };

const WarehousesList = ({
  history,
  is_open_create_modal,
  setOpenCreateModal,
}) => {
  const [warehouse_edit_modal, setWarehouseEditModal] = useState(default_state);
  const [warehouse_delete_modal, setWarehouseDeleteModal] = useState(null);

  const onClose = () => setWarehouseEditModal(default_state);

  return (
    <div className="box-7">
      <MainList
        query_key="warehouses"
        api_path="/warehouses"
        api_context="ui_index"
        title="Lista Magazynów"
        sort_column="id"
        sort_direction="desc"
        sort={sort}
        filters={filters}
        renderActions={(item) => [
          {
            type: "empty_position",
            handleClick: () =>
              history.push(`/warehouses/${item.id}/empty_positions`),
          },
          {
            type: "double_position",
            handleClick: () =>
              history.push(`/warehouses/${item.id}/double_positions`),
          },
          {
            type: "close_position",
            handleClick: () =>
              history.push(`/warehouses/${item.id}/close_positions`),
          },
          {
            type: "empty_stock_position",
            handleClick: () =>
              history.push(`/warehouses/${item.id}/empty_stock_positions`),
          },
          {
            type: "preview",
            handleClick: () => history.push(`/warehouses/${item.id}`),
          },
          {
            type: "edit",
            handleClick: () =>
              setWarehouseEditModal({
                type: "edit",
                data: item,
              }),
          },
          // {
          //   type: "remove",
          //   handleClick: () =>
          //     setWarehouseDeleteModal({
          //       id: item.id,
          //       name: item.name,
          //     }),
          // },
        ]}
        renderItem={({ id, name, city, street }) => (
          <>
            <td>{id}</td>
            <td>{name}</td>
            <td>{street}</td>
            <td>{city}</td>
          </>
        )}
      >
        {warehouse_edit_modal?.type === "edit" && (
          <ModalEditWarehouse
            handleClose={onClose}
            {...warehouse_edit_modal.data}
            initialValues={{
              name: warehouse_edit_modal?.data?.name || "",
              street: warehouse_edit_modal?.data?.street || "",
              city: warehouse_edit_modal?.data?.city || "",
              zip_code: warehouse_edit_modal?.data?.zip_code || "",
              country_code: warehouse_edit_modal?.data?.country_code || "",
              is_virtual: warehouse_edit_modal?.data?.is_virtual || "",
              erp_id: warehouse_edit_modal?.data?.erp_id || "",
            }}
          />
        )}
        {warehouse_delete_modal?.id && (
          <ModalDeleteWarehouse
            {...warehouse_delete_modal}
            handleClose={() => setWarehouseDeleteModal(null)}
          />
        )}
        {is_open_create_modal && (
          <ModalCreateWarehouse handleClose={() => setOpenCreateModal(false)} />
        )}
      </MainList>
    </div>
  );
};

export default withRouter(WarehousesList);
